import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Switch, Button, Spinner, Tooltip } from "@material-tailwind/react";

import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";

import ProductForm from "./Product_form";
import ProductInventaire from "./Product_inventaire";

import { ToastContainer, toast } from "react-toastify";
import { deleteOneProductApi, getAllProductsApi, updateProductStatusApi, archiveProductApi, getArchivedProductsApi } from "api/products";
import { getAllProductsCategoriesApi } from "api/filtersData";
import { FaArchive, FaBoxOpen } from "react-icons/fa";

function ProductTable({ accessList }) {
  const [clienFormAction, setClienFormAction] = useState("show");

  const [showProductFormModale, setShowProductFormModale] = useState(false);
  const [showInvetaireModale, setShowInvetaireModale] = useState(false);
  const [showArchivedModale, setShowArchivedModale] = useState(false);
  const [archivedProducts, setArchivedProducts] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingXcel, setIsLoadingXcel] = useState(false);

  const [productsData, setProductsData] = useState([]);

  const [productsCategories, setProductsCategories] = useState([])

  const [inputFilterValue, setInputFilterValue] = useState({
    Name: "",
    Code: "",
    Categorie: "",
    Fournisseur: "",
  });

  const [selectedProductID, setSelectedProductID] = useState("")
  const [statusFilter, setStatusFilter] = useState("")

  useEffect(() => {
    getInitialData(
      inputFilterValue.Name,
      inputFilterValue.Code,
      inputFilterValue.Categorie,
      inputFilterValue.Fournisseur
    );
    getAllProductsCategories()
  }, []);

  const getAllProductsCategories = async () => {
    try {
      const productsCategories = await getAllProductsCategoriesApi("")
      setProductsCategories(productsCategories)
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleProductChangeStatus = async (id, category) => {
    try {
      await updateProductStatusApi(id, category)

      toast.success("Modifiée", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      getInitialData(
        inputFilterValue.Name,
        inputFilterValue.Code,
        inputFilterValue.Categorie
      );
    }
    catch(err) {
      console.log(err)
    }
  }

  const getInitialData = async (Name, Code, Categorie, Fournisseur = "") => {
    try {
      setIsLoading(true);
      const response = await getAllProductsApi(Name.trim(), Code.trim(), Categorie.trim(), Fournisseur.trim());
      setProductsData(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const hadleShowToast = (type, message) => {
    if (type === "success") {
      setShowProductFormModale(!showProductFormModale);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      getInitialData(
        inputFilterValue.Name,
        inputFilterValue.Code,
        inputFilterValue.Categorie,
        inputFilterValue.Fournisseur
      );
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleFiltersInputChange = (e) => {
    const { name, value } = e.target;
    setInputFilterValue({ ...inputFilterValue, [name]: value });

    if(name == "Categorie")
      inputFilterValue.Categorie = value

    // getInitialData(
    //   inputFilterValue.Name,
    //   inputFilterValue.Code,
    //   inputFilterValue.Categorie
    // );
  };

  const handleFilterData = () => {
    getInitialData(
      inputFilterValue.Name,
      inputFilterValue.Code,
      inputFilterValue.Categorie,
      inputFilterValue.Fournisseur
    );
  }

  const handleDeleteProduct = (id, categoryID) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          text: "Toutes les entrées de stock liées à ce produit seront également supprimées.",
          confirmButtonText: "Supprimer",
          cancelButtonText: "Annuler",
          showCancelButton: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const response = await deleteOneProductApi(id, categoryID);

            getInitialData(
              inputFilterValue.Name,
              inputFilterValue.Code,
              inputFilterValue.Categorie,
              inputFilterValue.Fournisseur
            );

              // Show success message with stock deletion info
              const stockCount = response.deletedStockCount || 0;
              const stockEnterCount = response.deletedStockEnterCount || 0;
              
              let message = "Produit supprimé avec succès.";
              if (stockCount > 0 || stockEnterCount > 0) {
                message += `\n\n${stockCount} entrée(s) de stock et ${stockEnterCount} entrée(s) de stock entrant ont été supprimées.`;
              }

              Swal.fire({
                icon: "success",
                title: "Supprimée",
                text: message,
                confirmButtonText: "OK"
              });
            } catch (err) {
              console.log(err);
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: err?.response?.data?.error || "Erreur lors de la suppression",
                confirmButtonText: "OK"
              });
            }
          }
        })
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Une erreur est survenue",
        confirmButtonText: "OK"
      });
    }
  };

  const handleProductFormPopup = (action, id) => {
    try {
      setShowProductFormModale(!showProductFormModale);
      setClienFormAction(action);

      setSelectedProductID(id)
    } catch (err) {
      console.log(err);
    }
  };

  const handleInventaireModal = () => {
    try {
      setShowInvetaireModale(!showInvetaireModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleArchiveProduct = async (id) => {
    try {
      await archiveProductApi(id);
      toast.success("Produit archivé", { position: "top-right", autoClose: 3000, theme: "colored" });
      getInitialData(inputFilterValue.Name, inputFilterValue.Code, inputFilterValue.Categorie, inputFilterValue.Fournisseur);
    } catch (err) {
      console.log(err);
      toast.error("Erreur lors de l'archivage", { position: "top-right", autoClose: 3000, theme: "colored" });
    }
  };

  const handleShowArchivedModal = async () => {
    try {
      const data = await getArchivedProductsApi();
      setArchivedProducts(data);
      setShowArchivedModale(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleUnarchiveProduct = async (id) => {
    try {
      await archiveProductApi(id);
      const data = await getArchivedProductsApi();
      setArchivedProducts(data);
      toast.success("Produit désarchivé", { position: "top-right", autoClose: 3000, theme: "colored" });
      getInitialData(inputFilterValue.Name, inputFilterValue.Code, inputFilterValue.Categorie, inputFilterValue.Fournisseur);
    } catch (err) {
      console.log(err);
      toast.error("Erreur lors du désarchivage", { position: "top-right", autoClose: 3000, theme: "colored" });
    }
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />
      <Dialog
        size="xl"
        open={showProductFormModale}
        handler={handleProductFormPopup}
      >
        <DialogHeader>
          <p className="w-full text-center">
            {clienFormAction === "add"
              ? "Nouveau produit"
              : clienFormAction === "edite"
              ? "Modifier le produit"
              : "Voir les details de produit"}
          </p>
        </DialogHeader>
        <DialogBody>
          <ProductForm
            closePopup={handleProductFormPopup}
            clienFormAction={clienFormAction}
            showToast={hadleShowToast}
            productID={selectedProductID}
          />
        </DialogBody>
      </Dialog>
      <Dialog
        size="xl"
        open={showInvetaireModale}
        handler={handleInventaireModal}
      >
        <DialogHeader>
          <p className="w-full text-center">Liste des inventaires</p>
        </DialogHeader>
        <DialogBody className="h-[80vh] overflow-scroll">
          <ProductInventaire closePopup={handleInventaireModal} />
        </DialogBody>
      </Dialog>

      <Dialog size="xl" open={showArchivedModale} handler={() => setShowArchivedModale(false)}>
        <DialogHeader>
          <p className="w-full text-center">Produits archivés</p>
        </DialogHeader>
        <DialogBody className="h-[80vh] overflow-scroll">
          {archivedProducts.length === 0 ? (
            <p className="text-center text-gray-500 mt-8">Aucun produit archivé</p>
          ) : (
            <table className="w-full">
              <thead>
                <tr>
                  <th className="border-b border-gray-200 pb-2 text-start text-xs text-gray-600">Catégorie</th>
                  <th className="border-b border-gray-200 pb-2 text-start text-xs text-gray-600">Produit</th>
                  <th className="border-b border-gray-200 pb-2 text-start text-xs text-gray-600">Code</th>
                  <th className="border-b border-gray-200 pb-2 text-start text-xs text-gray-600">Prix HT</th>
                  <th className="border-b border-gray-200 pb-2 text-start text-xs text-gray-600">Action</th>
                </tr>
              </thead>
              <tbody>
                {archivedProducts.map((el) => (
                  <tr key={el._id}>
                    <td className="py-3 text-sm text-navy-700 dark:text-white">{el.Categorie}</td>
                    <td className="py-3 text-sm font-bold text-navy-700 dark:text-white">{el.Name}</td>
                    <td className="py-3 text-sm text-navy-700 dark:text-white">{el.Code}</td>
                    <td className="py-3 text-sm text-navy-700 dark:text-white">{parseFloat(el.Price || 0).toFixed(3)}</td>
                    <td className="py-3">
                      <button
                        onClick={() => handleUnarchiveProduct(el._id)}
                        className="flex items-center gap-1 rounded-lg bg-green-500 px-3 py-1 text-xs font-semibold text-white hover:bg-green-400"
                      >
                        <FaBoxOpen size={14} /> Désarchiver
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0">
          Liste des produits
        </div>
        {
          accessList.Add &&
          <Button
          onClick={() => handleProductFormPopup("add", null)}
          className="linear mb-5 rounded-[10px] bg-gray-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Nouveau produit
          </Button>
        }

        {
          accessList.Inventaire &&
          <Button
          onClick={() => handleInventaireModal()}
          className="linear mb-5 rounded-[10px] bg-green-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-green-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Inventaire
          </Button>
        }

        {
          accessList.Archive &&
          <Button
            onClick={handleShowArchivedModal}
            className="linear mb-5 flex items-center gap-2 rounded-[10px] bg-yellow-600 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-yellow-500 md:mb-0"
          >
            <FaArchive size={14} /> Produits archivés
          </Button>
        }
      </header>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par catégorie :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

              name="Categorie"
              value={inputFilterValue.Categorie}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              {
                productsCategories.map(el => (
                  <option value={el._id}>{el.Name}</option>
                ))
              }
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par produit :
          </small>
          <div>
            <input
              type="text"
              id=""
              placeholder="Tout"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="Name"
              value={inputFilterValue.Name}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par code produit :
          </small>
          <div>
            <input
              type="text"
              id=""
              placeholder="Tout"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="Code"
              value={inputFilterValue.Code}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par fournisseur :
          </small>
          <div>
            <input
              type="text"
              id=""
              placeholder="Tout"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="Fournisseur"
              value={inputFilterValue.Fournisseur}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par statut :
          </small>
          <div>
            <select
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">Tous</option>
              <option value="expired">Expiré</option>
              <option value="alerte">Alerte stock</option>
              <option value="rupture">Rupture de stock</option>
            </select>
          </div>
        </div>
        <div>
          <Button
            className="linear mb-5 rounded-[10px] bg-green-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-green-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
            onClick={handleFilterData}
          >
            Filtrer
          </Button>
        </div>
      </div>

      <div
        className="mt-8 overflow-x-scroll w-full"
        style={{ height: "300px", overflowY: "scroll" }}
      >
        <table className="w-full">
          <thead>
            <tr>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Catégories</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Produits</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Code des Produits</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Prix HT</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Tva %</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Prix TTC</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Qté en Stock
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  1ère date d'expiration
                </p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Actions</p>
              </th>
              <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Activer/Désactiver
                </p>
              </th>
            </tr>
          </thead>

          {isLoading ? (
            <div className="flex w-full items-center justify-center">
              <Spinner className="h-12 w-12" />
            </div>
          ) : (
            <tbody>
              {productsData.filter((el) => {
                if (!statusFilter) return true;
                const parsedDisponible = parseFloat(el?.Disponible) || 0;
                const parsedAlertStock = parseFloat(el?.AlertStock) || 0;
                const isOutOfStock = parsedDisponible <= 0;
                const isNearOutOfStock = !isOutOfStock && parsedAlertStock > 0 && parsedDisponible <= parsedAlertStock;
                const earliestExp = el?.productExpiredDate ? new Date(el.productExpiredDate) : null;
                const diffDays = earliestExp && !isNaN(earliestExp)
                  ? (earliestExp.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
                  : null;
                // a product with 0 stock across every lot has nothing left to expire
                const isExpired = diffDays !== null && diffDays < 0 && !isOutOfStock;
                if (statusFilter === "expired") return isExpired;
                if (statusFilter === "alerte") return isNearOutOfStock;
                if (statusFilter === "rupture") return isOutOfStock;
                return true;
              }).map((el, index) => {
                const parsedDisponible = parseFloat(el?.Disponible) || 0;
                const parsedAlertStock = parseFloat(el?.AlertStock) || 0;
                const isOutOfStock = parsedDisponible <= 0;
                const isNearOutOfStock =
                  !isOutOfStock &&
                  parsedAlertStock > 0 &&
                  parsedDisponible <= parsedAlertStock;
                const earliestExp = el?.productExpiredDate
                  ? new Date(el.productExpiredDate)
                  : null;
                const now = new Date();
                const diffDays =
                  earliestExp && !isNaN(earliestExp)
                    ? (earliestExp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
                    : null;
                // a product with 0 stock across every lot has nothing left to expire
                const isExpired = diffDays !== null && diffDays < 0 && !isOutOfStock;
                const isExpiringSoon = diffDays !== null && diffDays >= 0 && diffDays <= 60;
                const earliestExpStr =
                  earliestExp && !isNaN(earliestExp)
                    ? earliestExp.toISOString().split("T")[0].split("-").reverse().join("/")
                    : "";

                return (
                <tr key={`${el?._id || el?.Code || "product"}-${index}`}>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-2">
                      {el?.Categorie}
                      <span
                        className={`inline-flex rounded-full px-2 py-1 text-[10px] font-semibold ${
                          isExpired
                            ? "bg-red-100 text-red-700"
                            : isExpiringSoon
                            ? "bg-orange-100 text-orange-700"
                            : "bg-green-100 text-green-700"
                        }`}
                      >
                        {isExpired
                          ? "Expiré"
                          : isExpiringSoon
                          ? "Expire bientôt"
                          : "OK"}
                      </span>
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el?.Name}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el?.Code}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {parseFloat(el?.Price).toFixed(3)}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el?.HaveTVA}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {parseFloat(el?.PriceTTC).toFixed(3)}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {parsedDisponible.toFixed(3)}
                    </p>
                    {(isOutOfStock || isNearOutOfStock) && (
                      <span
                        className={`mt-2 inline-flex rounded-full px-2 py-1 text-[11px] font-semibold text-white ${
                          isOutOfStock ? "bg-red-500" : "bg-yellow-500 text-gray-900"
                        }`}
                      >
                        {isOutOfStock ? "Rupture de stock" : "Alerte stock"}
                      </span>
                    )}
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {earliestExpStr || "-"}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      <div className="flex">
                        {
                          accessList.Read &&
                          <Tooltip content="Material Tailwind" placement="top">
                            {
                              <IoEyeSharp
                                size={20}
                                color="gray"
                                className="mr-4 cursor-pointer"
                                onClick={() =>
                                  handleProductFormPopup("show", el._id)
                                }
                              />
                            }
                          </Tooltip>
                        }

                        {
                          accessList.Update &&
                          <HiPencilAlt
                            size={20}
                            color="#236571"
                            className="mr-4 cursor-pointer"
                            onClick={() =>
                              handleProductFormPopup("edite", el._id)
                            }
                          />
                        }

                        {
                          accessList.Delete &&
                          <FaTrash
                            size={20}
                            color="#cf503f"
                            className="mr-4 cursor-pointer"
                            onClick={() => handleDeleteProduct(el._id, el.CategorieID)}
                          />
                        }

                        {
                          accessList.Archive &&
                          <Tooltip content="Archiver" placement="top">
                            <FaArchive
                              size={18}
                              color="#b45309"
                              className="mr-4 cursor-pointer"
                              onClick={() => handleArchiveProduct(el._id)}
                            />
                          </Tooltip>
                        }

                      </div>
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      <div className="flex justify-center">
                        {
                          accessList.Update &&
                          <Switch checked={el.isActive} onChange={() => handleProductChangeStatus(el._id, el.CategorieID)} />
                        }
                      </div>
                    </p>
                  </td>
                </tr>
              )})}
            </tbody>
          )}
        </table>
      </div>
    </Card>
  );
}

export default ProductTable;
